import React from "react";

export const b = (...chunks: string[]) => <b>{chunks}</b>;
